import { render, staticRenderFns } from "./LoaderSvg.vue?vue&type=template&id=d8853620&scoped=true&"
var script = {}
import style0 from "./LoaderSvg.vue?vue&type=style&index=0&id=d8853620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8853620",
  null
  
)

export default component.exports